import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RadioGroup, Radio, Textfield, Switch } from 'react-mdl'
import { SelectField, Option } from 'react-mdl-extra';
import { ChannelConfigStepper } from './ChannelConfigStepper';

import '../styles/styles.css';

const states = [
    {
        "name": "Alabama",
        "abbreviation": "AL"
    },
    {
        "name": "Alaska",
        "abbreviation": "AK"
    },
    {
        "name": "American Samoa",
        "abbreviation": "AS"
    },
    {
        "name": "Arizona",
        "abbreviation": "AZ"
    },
    {
        "name": "Arkansas",
        "abbreviation": "AR"
    },
    {
        "name": "California",
        "abbreviation": "CA"
    },
    {
        "name": "Colorado",
        "abbreviation": "CO"
    },
    {
        "name": "Connecticut",
        "abbreviation": "CT"
    },
    {
        "name": "Delaware",
        "abbreviation": "DE"
    },
    {
        "name": "District Of Columbia",
        "abbreviation": "DC"
    },
    {
        "name": "Federated States Of Micronesia",
        "abbreviation": "FM"
    },
    {
        "name": "Florida",
        "abbreviation": "FL"
    },
    {
        "name": "Georgia",
        "abbreviation": "GA"
    },
    {
        "name": "Guam",
        "abbreviation": "GU"
    },
    {
        "name": "Hawaii",
        "abbreviation": "HI"
    },
    {
        "name": "Idaho",
        "abbreviation": "ID"
    },
    {
        "name": "Illinois",
        "abbreviation": "IL"
    },
    {
        "name": "Indiana",
        "abbreviation": "IN"
    },
    {
        "name": "Iowa",
        "abbreviation": "IA"
    },
    {
        "name": "Kansas",
        "abbreviation": "KS"
    },
    {
        "name": "Kentucky",
        "abbreviation": "KY"
    },
    {
        "name": "Louisiana",
        "abbreviation": "LA"
    },
    {
        "name": "Maine",
        "abbreviation": "ME"
    },
    {
        "name": "Marshall Islands",
        "abbreviation": "MH"
    },
    {
        "name": "Maryland",
        "abbreviation": "MD"
    },
    {
        "name": "Massachusetts",
        "abbreviation": "MA"
    },
    {
        "name": "Michigan",
        "abbreviation": "MI"
    },
    {
        "name": "Minnesota",
        "abbreviation": "MN"
    },
    {
        "name": "Mississippi",
        "abbreviation": "MS"
    },
    {
        "name": "Missouri",
        "abbreviation": "MO"
    },
    {
        "name": "Montana",
        "abbreviation": "MT"
    },
    {
        "name": "Nebraska",
        "abbreviation": "NE"
    },
    {
        "name": "Nevada",
        "abbreviation": "NV"
    },
    {
        "name": "New Hampshire",
        "abbreviation": "NH"
    },
    {
        "name": "New Jersey",
        "abbreviation": "NJ"
    },
    {
        "name": "New Mexico",
        "abbreviation": "NM"
    },
    {
        "name": "New York",
        "abbreviation": "NY"
    },
    {
        "name": "North Carolina",
        "abbreviation": "NC"
    },
    {
        "name": "North Dakota",
        "abbreviation": "ND"
    },
    {
        "name": "Northern Mariana Islands",
        "abbreviation": "MP"
    },
    {
        "name": "Ohio",
        "abbreviation": "OH"
    },
    {
        "name": "Oklahoma",
        "abbreviation": "OK"
    },
    {
        "name": "Oregon",
        "abbreviation": "OR"
    },
    {
        "name": "Palau",
        "abbreviation": "PW"
    },
    {
        "name": "Pennsylvania",
        "abbreviation": "PA"
    },
    {
        "name": "Puerto Rico",
        "abbreviation": "PR"
    },
    {
        "name": "Rhode Island",
        "abbreviation": "RI"
    },
    {
        "name": "South Carolina",
        "abbreviation": "SC"
    },
    {
        "name": "South Dakota",
        "abbreviation": "SD"
    },
    {
        "name": "Tennessee",
        "abbreviation": "TN"
    },
    {
        "name": "Texas",
        "abbreviation": "TX"
    },
    {
        "name": "Utah",
        "abbreviation": "UT"
    },
    {
        "name": "Vermont",
        "abbreviation": "VT"
    },
    {
        "name": "Virgin Islands",
        "abbreviation": "VI"
    },
    {
        "name": "Virginia",
        "abbreviation": "VA"
    },
    {
        "name": "Washington",
        "abbreviation": "WA"
    },
    {
        "name": "West Virginia",
        "abbreviation": "WV"
    },
    {
        "name": "Wisconsin",
        "abbreviation": "WI"
    },
    {
        "name": "Wyoming",
        "abbreviation": "WY"
    }
]

export class SMSStepper extends Component {

  static propTypes = {
    channel: PropTypes.object,
    channelType: PropTypes.string.isRequired,
    fetchChannelProviders: PropTypes.func.isRequired,
    channelAPI: PropTypes.func.isRequired,
    createChannel: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
    addingChannel: PropTypes.bool.isRequired
  }

  constructor(props,context) {
    super(props,context);

    this.state = {
      stateSelected: -1,
      stateCode: '',
      areaCode: '',
      phoneNumbers: [],
      providerId: null,
      tollFree: false
    }

    this.searchPhoneNumbers = this.searchPhoneNumbers.bind(this)
    this.phoneNumberSelected = this.phoneNumberSelected.bind(this);
    this.searchTollFreePhoneNumbers = this.searchTollFreePhoneNumbers.bind(this);

    this.handleTextFieldChange = this.handleTextFieldChange.bind(this);
    this.handleNextStep = this.handleNextStep.bind(this);
    this.renderStep = this.renderStep.bind(this);
  }

  componentWillMount() {
    if (this.props.addingChannel) {
      this.props.fetchChannelProviders((response, err) => {
        if (!err) {
          const providerId = response[0].id

          const components = providerId.split('-');
          components.shift()
          const id = components.join('-')

          console.log('Got SMS Provider', id);
          this.setState( {providerId: providerId} )
        }
      })
    }
  }

  handleNextStep() {
    const { stateCode, areaCode, tollFree } = this.state
    const { stepper } = this.channelConfigStepper
    const step = stepper.state.activeStep
    if (step === 1) {
      if (this.props.addingChannel) {
        if (tollFree) {
            this.searchTollFreePhoneNumbers()
        }
        else if (stateCode || areaCode) {
          this.searchPhoneNumbers(stateCode, areaCode)
        }
      }
      else {
        this.nextStep()
      }
    }
    else if (step === 2) {
      if (this.props.addingChannel) {
        if (this.state.selectedPhoneNumber !== undefined) {
          this.save()
        }
      }
      else {
        this.nextStep()
      }
    }
  }

  nextStep() {
    if (this.channelConfigStepper.isLastStep()) {
      this.props.goBack()
    }
    else {
      this.channelConfigStepper.stepper.nextStep()
    }
  }

  save() {
    const {selectedPhoneNumber, phoneNumbers, providerId} = this.state
    const phone = phoneNumbers.filter(function(e) { return e.number === selectedPhoneNumber})[0]
    const clean_phone = selectedPhoneNumber.replace('+', '')

    const newChannel = {
      params: {
        phone: clean_phone
      },
      provider: `${providerId}-${clean_phone}`,
      title: phone.formattedNumber,
      enabled: true
    }

    this.props.createChannel(newChannel, (response, err) => {
      if (!err) {
       this.nextStep()
      }
    })
  }

  handleTextFieldChange(event) {
    const state = {...this.state}
    state[event.target.name] = event.target.value;
    this.setState(state);
  }

  renderStep(stepJson, step) {
    if (step === 1) {
      //search criteria
      if (this.props.addingChannel) {
        const {stateSelected, areaCode, tollFree} = this.state
        if (!tollFree) {
          return (
              <div>
              <div style={{display: 'table-row'}}>
                <div style={{display: 'table-cell', width:'75px'}}>
                  Toll Free
                </div>
                <div style={{display: 'table-cell'}}>
                  <Switch onChange={()=>this.setState({tollFree:!tollFree})} />
                </div>
              </div>

              <SelectField label={'State Code'} value={stateSelected} onChange={v => this.setState({stateSelected:v, stateCode:states[v].abbreviation})} style={{maxWidth:'100px'}}>
              {states.map((s, index)=>{
                return <Option key={index} value={index}>{s.abbreviation}</Option>
              })}
              </SelectField>
              &nbsp;or&nbsp;
              <Textfield name="areaCode" onChange={this.handleTextFieldChange} label="Area Code" style={{width: '150px'}} value={areaCode} floatingLabel/>
              </div>
          )
        }
        else {
          return (
              <div style={{display: 'table-row'}}>
                <div style={{display: 'table-cell', width:'75px'}}>
                  Toll Free
                </div>
                <div style={{display: 'table-cell'}}>
                  <Switch checked onChange={()=>this.setState({tollFree:!tollFree})} />
                </div>
              </div>
          )
        }
      }
    }
    if (step === 2) {
      if (this.props.addingChannel) {
        return <div>{this.renderPhoneNumbers()}</div>
      }
      else {
        return <div>Phone number: {this.props.channel ? `+${this.props.channel.params.phone}` : ''}</div>
      }
    }

    return <div></div>
  }

  render(){
    const { channel, channelType } = this.props
    return (
      <div>
        <ChannelConfigStepper ref={(s) => this.channelConfigStepper = s} channelType={channelType} channel={channel} onBeforeNextStep={this.handleNextStep} renderStep={this.renderStep}/>
      </div>
    )
  }

  //http://dev.bandwidth.com/ap-docs/methods/availableNumbers/getAvailableNumbersLocal.html
  searchPhoneNumbers(stateCode, areaCode) {
    const params = {
      type: 'local',
      params: {
        state: stateCode,
        areaCode: areaCode
      }
    };
    this.props.channelAPI(this.state.providerId, 'available_numbers', params, (response, err) => {
      if (!err) {
        this.setState( {phoneNumbers: response, selectedPhoneNumber: response[0].number} )
        this.nextStep()
      }
    })
  }

  searchTollFreePhoneNumbers() {
    const params = {
      type: 'tollFree',
      params: { }
    };
    this.props.channelAPI(this.state.providerId, 'available_numbers', params, (response, err) => {
      if (!err) {
        this.setState( {phoneNumbers: response, selectedPhoneNumber: response[0].number} )
        this.nextStep()
      }
    })
  }

  //  SELECT PHONE

  phoneNumberSelected(event) {
    this.setState({selectedPhoneNumber: event.target.value});
  }

  renderPhoneNumbers() {
    const {phoneNumbers, selectedPhoneNumber} = this.state

    if (phoneNumbers.length === 0) {
      return <div></div>
    }

    return (
      <div>
        <RadioGroup name="phone_number" container="ul" childContainer="li" value={selectedPhoneNumber} onChange={this.phoneNumberSelected}>
          {
            phoneNumbers.map((phone) => (
              <Radio key={phone.number} value={phone.number}>{phone.formattedNumber}</Radio>
            ))
          }
        </RadioGroup>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/containers/SMSStepper.js